import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

const ProductCard = ({ product, onWishlistToggle, isWishlisted = false }) => {
    const navigate = useNavigate();

    const handleWishlist = (e) => {
        e.stopPropagation();
        if (onWishlistToggle) onWishlistToggle(product.id);
    };

    return (
        <div
            onClick={() => navigate('/template9/product')}
            className="group cursor-pointer border border-[#E2E8F0] rounded-none overflow-hidden hover:border-l-2 hover:border-l-[#2563EB] transition-all duration-300 bg-white"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
            {/* Image Container */}
            <div className="relative aspect-[3/4] overflow-hidden">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {product.tag && (
                    <span className="absolute top-3 left-3 bg-[#2563EB] text-white text-[10px] sm:text-xs font-semibold px-2.5 py-1 tracking-wider uppercase rounded-none">
                        {product.tag}
                    </span>
                )}
                {product.originalPrice && (
                    <span className="absolute top-3 left-3 bg-[#0F172A] text-white text-[10px] sm:text-xs font-semibold px-2.5 py-1 tracking-wider uppercase rounded-none">
                        SALE
                    </span>
                )}
                <button
                    onClick={handleWishlist}
                    className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white/90 hover:bg-white transition-colors duration-200 rounded-none"
                >
                    <Heart
                        className={`w-4 h-4 ${isWishlisted ? 'fill-[#2563EB] text-[#2563EB]' : 'text-[#64748B]'}`}
                    />
                </button>
            </div>

            {/* Info */}
            <div className="p-3 sm:p-4">
                <p className="text-xs text-[#64748B] uppercase tracking-wider mb-1">
                    {product.category || 'Indian Wear'}
                </p>
                <h3 className="text-sm sm:text-base font-medium text-[#0F172A] mb-1 truncate">
                    {product.name}
                </h3>
                <div className="flex items-center gap-2">
                    <p className="text-sm sm:text-base font-semibold text-[#2563EB]">
                        {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}
                    </p>
                    {product.originalPrice && (
                        <p className="text-xs text-[#64748B] line-through">
                            {typeof product.originalPrice === 'number' ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}` : product.originalPrice}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
